export const styles = theme => ({
    root: {
      marginTop: theme.spacing(2),
      padding : theme.spacing(3),
      // width : '100%',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom : '8px',
    },
    title : {
      fontSize : '1.5rem',
    },
    textField: {
      marginRight: theme.spacing(1),
      width: '100%',
    },
    input : {
    },
    inputImage: {
      display: 'block',
     },
    label : {
      fontWeight :410
    },
    button: {
      margin: '0.5rem',
    },   
    image : {
      borderRadius: '50%',
      margin: 'auto',
      height: '200px',
      width: '200px',
      // border: '2px solid #F2F2F2',
      boxShadow :'0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);',
      backgroundSize : 'cover',
      backgroundPosition : 'center',
      cursor: 'pointer', 
    },
    containerImage : {
      borderRadius: '50%',
      margin: 'auto',
      position: 'relative'
    },
    camera: {
      position: 'absolute',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      width: '44px',
      height: '44px',
      marginTop: '-50px',
      marginLeft: '150px',
      border: '4px solid #fff',
      backgroundColor:' #ff513f',
      borderRadius: '50%',
    },
    iconCamera:{
      width: '24px'
    },
    wrapSelected: {
      paddingTop: '16px !important',
    },
    MultiSelect: {
      padding: '0px',
      flexGrow: '0',
    },
    selectedMenu: {
      '&:focus': {
        backgroundColor: 'transparent',
      }
    },
  });